<template>
    <el-dialog title="查询物料选择仓位" :visible.sync="DialogVisible" width="80%" @close="XXX" :close-on-click-modal="false">

        <d-query-input style="" :options="options" @query="queryBySelect" @clear="clearQuery" width="340px"
            :pageInfo="pageInfo" />


        <el-table style="margin-top: 5px;" :data="responseData" :header-cell-style="{'text-align':'center'}"
            :cell-style="{'padding':'0px'}" border stripe id="xxxxTable" @selection-change="handleSelectionChange">

            <!-- 选择多行数据时使用 Checkbox。 -->
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>

            <el-table-column label="行" type="index" :index="indexMethod" align="center">
            </el-table-column>

            <el-table-column sortable prop="materialNumber" label="物料编号" align="center">
            </el-table-column>

            <el-table-column sortable prop="materialName" label="物料名称" align="center">
            </el-table-column>

            <el-table-column sortable prop="warehouseName" label="仓库" align="center">
            </el-table-column>
            <el-table-column sortable prop="positionName" label="仓位" align="center">
            </el-table-column>

            <el-table-column sortable prop="count" label="库存数(匹)" align="center">
            </el-table-column>
            <el-table-column sortable prop="productWeight_change" label="过磅重量(千克)" align="center">
            </el-table-column>
            <el-table-column sortable prop="productLength_change" label="米数(米)" align="center">
            </el-table-column>

        </el-table>

        <el-pagination style="text-align: center" background layout="prev, pager, next"
            @current-change="handleCurrentChange" :page-size="pageInfo.size" :current-page="pageInfo.page"
            :page-count="totalPages">
        </el-pagination>


        <div slot="footer">
            <el-button type="" @click="cancel()">取消</el-button>
            <el-button type="primary" @click="onSubmit()">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/factory/machine/list/add'

    import {
        dQueryInput
    } from '@/components/projectComponents'

    export default {
        components: {
            dQueryInput
        },

        data() {
            return {
                DialogVisible: false,
                responseData: [
                    // 调试用假数据--正式版注释掉
                    // {
                    //     materialNumber: '1111',
                    //     materialName: '测试1',
                    //     warehouse: '测试仓库1',
                    //     position: '测试仓位1',
                    // },
                ],

                //分页相关--sta
                pageInfo: {
                    page: 1,
                    size: 10,
                },
                totalPages: 0,
                //分页相关--end
                // 查询--sta
                options: [{
                    label: '物料名称',
                    value: 'materialName'
                }, {
                    label: '物料编号',
                    value: 'materialNumber'
                }],
                // 查询--end

                // 选择多行数据时使用 Checkbox。
                multipleSelection: [], //列表选中多行。

                g_position_index: 0, //外层已经 有的索引下标。比实际行数 多1。
            }
        },
        methods: {
            // 外部调用，显示 对话框
            show(inputData) {
                if (inputData != undefined) {
                    // console.log("inputData=", inputData)
                }
                this.g_position_index = inputData

                this.DialogVisible = true
                //显示对话框 时候 要加载数据
                this.getWuLiaoList(1)
            },

            // 外部调用，取 选中的仓位列表。
            getPositionList() {
                return this.multipleSelection
            },

            // 监听回车按钮
            keyCodeListen() {
                // const code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode
                const code = event.keyCode
                if (code === 13) this.onSubmit()
            },
            // 点击 确定 按钮
            onSubmit() {
                if (0 === this.multipleSelection.length) {
                    this.$Message.closeAll()
                    this.$Message.error('还未选择 或者 列表 为空。')
                } else if (((this.g_position_index - 1) + this.multipleSelection.length) >= 11) { //最多只能10条记录
                    this.$Message.closeAll()
                    this.$Message.error('最多只能10条记录。')
                } else {
                    this.$emit('update') //触发 回调的 update函数???
                    this.DialogVisible = false
                }
            },
            // 点击取消按钮触发
            cancel() {
                this.DialogVisible = false
            },
            mounted() {
                document.addEventListener('keyup', this.keyCodeListen)
            },
            destroyed() {
                document.removeEventListener('keyup', this.keyCodeListen)
            },


            // 获取 胚布+原料 分页列表
            getWuLiaoList(val) {
                //---------------------
                this.pageInfo.page = val

                this.$requestBase({
                    url: 'v1/stock/list',
                    method: 'get',
                    params: this.pageInfo
                }).then(res => {
                    this.responseData = this.formatResponse(res.data.list)

                    this.totalPages = res.data.pages
                })
            },
            // 格式化 胚布+原料 列表
            formatResponse(response) {
                response.forEach((item, index) => {
                    item.local_id = index + 1
                    item.createTime = this.utils.timestampToTime(item.createTime, 2)

                    //米数：要从厘米 变成 米。
                    item.productLength_change = (item.productLength / 100).toFixed(2)

                    //过磅重量数值单位现在为克，应该转为千克。 
                    item.productWeight_change = (item.productWeight / 1000).toFixed(2)
                })
                return response
            },

            // 分页切换
            handleCurrentChange(newNum) {
                this.getWuLiaoList(newNum)
            },


            // 条件查询
            queryBySelect(pageInfo) {
                this.pageInfo = pageInfo
                this.getWuLiaoList(1)
            },
            // 清空条件查询
            clearQuery(pageInfo) {
                this.pageInfo = pageInfo
                this.getWuLiaoList(1)
            },

            //给 所有 表格 自动 加行号
            indexMethod(index) {
                return index + 1;
            },

            // 选择多行数据时使用 Checkbox。--sta
            //列表中 选中多行。
            handleSelectionChange(val) {
                // console.log("val=", val)
                this.multipleSelection = val
            },
            // 选择多行数据时使用 Checkbox。--end
        }
    }
</script>

<style lang="scss" scoped>
    .col-title {
        padding: 5px 0px;
        font-weight: bold;
    }

    .col-body {
        height: 400px;
        border: 1px solid #ccc;
        padding: 0px;
    }
</style>
